import {
  callApiCapNhatCanBo,
  callApiThemCanBoVaoNguoiDung,
  callApiCapNhatMenuCanBo,
  callAPiLayChiTietCanBo,
  callAPiLayDanhSachCanBo,
  callAPiLayMenuCanBo,
  callApiTaoCanBo,
  callApiUpload,
  callApiXoaNguoiDung,
  callApiXoaCanBo,
  callApiLayDanhSach,
  callApiCheckUserExisted,
  callAPiListCanBoPhanQuyen,
  callApiGetThongTinCanBo,
  callApiGetImageUser,
  callApiGetTruSo
} from "@/api/can-bo";
import {
  CAP_NHAT_CAN_BO_THANH_CONG,
  CAP_NHAT_MENU_CAN_BO_THANH_CONG,
  TAO_CAN_BO_THANH_CONG,
  UPLOAD_THANH_CONG,
  XOA_CAN_BO_THANH_CONG
} from "@/constants/message";
import { showMsgOk } from "@/utils/commonUtils";

// eslint-disable-next-line no-unused-vars
const layDanhSachCanBo = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    return callAPiLayDanhSachCanBo(payload)
        .then(res => {
          if (res && res.data.succeeded) {
            commit("LAY_DANH_SACH_CAN_BO_THANH_CONG", res.data.data);
          }
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
  });
};

const listCanBoPhanQuyen = async (context, payload) => {
  const response = await callAPiListCanBoPhanQuyen(payload.data);
  if (response && response.data.succeeded) {
    payload.onSuccess && payload.onSuccess(response.data.data);
  }
};

// eslint-disable-next-line no-unused-vars
const layDanhSachLanhDao = async ({ commit }, payload) => {
  const response = await callAPiLayDanhSachCanBo(payload);
  if (response && response.data.succeeded) {
    commit("LAY_DANH_SACH_LANH_DAO_THANH_CONG", response.data.data);
  }
};

// eslint-disable-next-line no-unused-vars
const layChiTietCanBo = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    return callAPiLayChiTietCanBo(payload)
        .then(res => {
          commit("LAY_CHI_TIET_CAN_BO_THANH_CONG", res.data.data);
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
  });
};



const layDanhSachTaiKhoan = async (context, payload) => {
  const response = await callApiLayDanhSach(payload);
  if (response && response.data.succeeded) {
    payload.onSuccess && payload.onSuccess(response.data.data);
  }
};

const layDanhSachMenu = async ({ commit }, payload) => {
  const response = await callAPiLayMenuCanBo(payload);
  if (response && response.data.succeeded) {
    commit("LAY_MENU_CAN_BO_THANH_CONG", response.data.data);
  }
};

const taoCanBo = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    return callApiTaoCanBo(payload.data)
      .then(res => {
        showMsgOk(TAO_CAN_BO_THANH_CONG);
        payload.onSuccess(res.data.data);
        commit("TAO_CAN_BO_THANH_CONG", res.data.data);
        resolve(res);
      })
      .catch(err => {
        reject(err.response);
      });
  });
};

const layThongTinCanBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetThongTinCanBo(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};

const capNhatCanBoNew = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCapNhatCanBo(payload.data)
      .then(response => {
        resolve(response);
        showMsgOk(CAP_NHAT_CAN_BO_THANH_CONG);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};

const capNhatCanBo = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    return callApiCapNhatCanBo(payload.data)
      .then(response => {
        showMsgOk(CAP_NHAT_CAN_BO_THANH_CONG);
        payload.onSuccess(response.data.data);
        commit("CAP_NHAT_CAN_BO_THANH_CONG", response.data.data);
        resolve(response);
      })
      .catch(err => {
        reject(err.response);
      });
  });
};

const themCanBoVaoNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemCanBoVaoNguoiDung(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};

// eslint-disable-next-line no-empty-pattern
const xoaCanBo = async (context, payload) => {
  const response = await callApiXoaCanBo(payload.data);
  if (response && response.data.succeeded) {
    showMsgOk(XOA_CAN_BO_THANH_CONG);
    payload.onSuccess();
  }
};

const xoaNguoiDung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaNguoiDung(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};

const upload = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    callApiUpload(payload.data)
      .then(res => {
        showMsgOk(UPLOAD_THANH_CONG);
        commit("UPLOAD_THANH_CONG", res.data.data, payload);
        payload.onSuccess && payload.onSuccess(res.data.data);
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
};

// eslint-disable-next-line no-empty-pattern
const capNhatMenuCanBo = async (context, payload) => {
  const response = await callApiCapNhatMenuCanBo(payload);
  if (response && response.data.succeeded) {
    showMsgOk(CAP_NHAT_MENU_CAN_BO_THANH_CONG);
    // commit("CAP_NHAT_MENU_CAN_BO_THANH_CONG", response.data.data);
    // payload.onSuccess();
  }
};

// eslint-disable-next-line no-empty-pattern
const checkUserExisted = async (context, payload) => {
  const response = await callApiCheckUserExisted(payload);
  if (response && response.data.succeeded) {
    return response.data;
  }
};


const getImageUser = async (context, payload) => {
  return new Promise((resolve, reject) => {
    return callApiGetImageUser(payload)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
  });
};

const changeAvartaUser = (context, payload) => {
  context.commit("CHANGE_AVARTA_USER", payload);
};

const getTruSo = async (context, payload) => {
  return new Promise((resolve, reject) => {
    return callApiGetTruSo(payload)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
  });
};


export default {
  layDanhSachCanBo,
  layDanhSachLanhDao,
  taoCanBo,
  capNhatCanBo,
  themCanBoVaoNguoiDung,
  xoaCanBo,
  xoaNguoiDung,
  layChiTietCanBo,
  upload,
  layDanhSachMenu,
  capNhatMenuCanBo,
  layDanhSachTaiKhoan,
  checkUserExisted,
  listCanBoPhanQuyen,
  layThongTinCanBo,
  capNhatCanBoNew,
  getImageUser,
  changeAvartaUser,
  getTruSo
};
